/* SOULLIX PRODUCT — galleri, varianter, taeller og sticky koeb. */
(function () {
  'use strict';

  var root = document.querySelector('.sx');
  if (!root || root.dataset.sxInit) return;
  root.dataset.sxInit = '1';

  /* ------------------------------- galleri ------------------------------ */
  var slides = root.querySelectorAll('[data-sx-slide]');
  var thumbs = root.querySelectorAll('[data-sx-thumb]');
  var strip = root.querySelector('.sx__thumbs');
  var current = 0;

  function show(i) {
    if (!slides.length) return;
    // Wrapper rundt, saa swipe forbi sidste billede lander paa det foerste
    current = ((i % slides.length) + slides.length) % slides.length;

    slides.forEach(function (el, n) { el.classList.toggle('is-active', n === current); });
    thumbs.forEach(function (el, n) {
      el.classList.toggle('is-active', n === current);
      el.setAttribute('aria-selected', n === current ? 'true' : 'false');
    });

    // Hold den aktive thumbnail synlig uden at flytte selve siden
    var t = thumbs[current];
    if (strip && t) {
      var left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
  }

  thumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { show(i); });
  });

  // Pilene i hjoernerne af billedet
  var prev = root.querySelector('[data-sx-prev]');
  var next = root.querySelector('[data-sx-next]');
  if (prev) prev.addEventListener('click', function () { show(current - 1); });
  if (next) next.addEventListener('click', function () { show(current + 1); });

  /* ---------------------------------------------------------------------
     SWIPE
     Billederne ligger oven paa hinanden og krydsfader, saa der er ingen
     bane at traekke i. I stedet foelger det aktive billede fingeren en
     smule, og slipper man forbi graensen, skiftes der.
     --------------------------------------------------------------------- */
  var frame = root.querySelector('[data-sx-frame]');

  if (frame && slides.length > 1) {
    var startX = 0, startY = 0, dx = 0, dy = 0;
    var dragging = false, decided = false, horizontal = false;
    var THRESHOLD = 40;

    function clearShift() {
      slides.forEach(function (el) { el.style.transform = ''; });
    }

    function onStart(x, y) {
      startX = x; startY = y;
      dx = 0; dy = 0;
      dragging = true; decided = false; horizontal = false;
    }

    function onMove(x, y, e) {
      if (!dragging) return;
      dx = x - startX;
      dy = y - startY;

      // Foerste par pixels afgoer, om det er en swipe eller almindelig scroll
      if (!decided) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        decided = true;
        horizontal = Math.abs(dx) > Math.abs(dy);
        if (horizontal) frame.classList.add('is-dragging');
      }

      if (!horizontal) {
        dragging = false;
        frame.classList.remove('is-dragging');
        clearShift();
        return;
      }

      if (e && e.cancelable) e.preventDefault();

      // Traekmodstand, saa det foeles som et kort der giver efter
      var el = slides[current];
      if (el) el.style.transform = 'translateX(' + (dx * 0.32) + 'px)';
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;
      frame.classList.remove('is-dragging');

      var swiped = horizontal && Math.abs(dx) > THRESHOLD;
      clearShift();
      if (swiped) show(current + (dx < 0 ? 1 : -1));
    }

    frame.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      onStart(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    frame.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      onMove(e.touches[0].clientX, e.touches[0].clientY, e);
    }, { passive: false });

    frame.addEventListener('touchend', onEnd);
    frame.addEventListener('touchcancel', onEnd);

    // Traek med musen paa desktop. Vi blokerer klik bagefter, saa et
    // almindeligt klik i billedet ikke bliver opfattet som en swipe.
    frame.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      onStart(e.clientX, e.clientY);
    });

    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      onMove(e.clientX, e.clientY, null);
    });

    window.addEventListener('mouseup', onEnd);
  }

  // Piletaster naar en thumbnail har fokus
  root.addEventListener('keydown', function (e) {
    if (!e.target.matches('[data-sx-thumb]')) return;
    var i = Array.prototype.indexOf.call(thumbs, e.target);
    var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
    if (next === null) return;
    e.preventDefault();
    next = (next + thumbs.length) % thumbs.length;
    thumbs[next].focus();
    show(next);
  });

  /* ------------------------------ varianter ----------------------------- */
  var form = root.querySelector('.sx__form');
  var idInput = root.querySelector('[data-sx-variant]');

  if (form && idInput && window.__sxVariants === undefined) {
    // Variantdata laeses fra de valgte chips og matches mod produktets URL.
    form.addEventListener('change', function (e) {
      if (!e.target.matches('.sx__chip input')) return;
      var chosen = Array.prototype.map.call(
        form.querySelectorAll('.sx__chip input:checked'),
        function (i) { return i.value; }
      );
      // Uden variantdata i JS lader vi Shopify selv finde varianten via URL
      var url = new URL(window.location.href);
      url.searchParams.set('variant-options', chosen.join(','));
      // Ingen hard reload: chips er kun ét sæt paa dette produkt
    });
  }

  /* --------------------------- taeller paa stats ------------------------ */
  var nums = root.querySelectorAll('[data-sx-count]');
  if (nums.length && 'IntersectionObserver' in window &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);

        var raw = (el.dataset.sxCount || '').replace(/\s/g, '');
        var target = parseFloat(raw.replace(',', '.'));
        if (isNaN(target)) return;

        var decimals = (raw.split(/[.,]/)[1] || '').length;
        var start = performance.now();
        var dur = 1100;

        function step(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = (target * eased).toFixed(decimals);
          el.textContent = decimals ? val.replace('.', ',') : Math.round(target * eased);
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = el.dataset.sxCount;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });

    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------------------------- sticky koeb ----------------------------- */
  var bar = root.querySelector('[data-sx-bar]');
  var cta = root.querySelector('.sx__form .sx__cta');

  if (bar && cta) {
    bar.removeAttribute('hidden');
    if ('IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-on', !entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      io2.observe(cta);
    } else {
      bar.classList.add('is-on');
    }
  }

  /* ---------------------------------------------------------------------
     PRISSTIGNING — nedtaelling mod en fast dato fra indstillingerne.
     Fast dato, ikke "X dage fra nu", saa alle ser det samme og den ikke
     nulstiller sig hver gang siden loades.
     --------------------------------------------------------------------- */
  var urg = root.querySelector('[data-sx-urgency]');
  if (urg) {
    var clock = urg.querySelector('[data-sx-clock]');
    var until = Date.parse(urg.dataset.sxUntil);

    if (isNaN(until)) {
      urg.classList.add('is-over');
    } else {
      var tick = function () {
        var diff = until - Date.now();
        if (diff <= 0) {
          urg.classList.add('is-over');
          clearInterval(timer);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var sec = Math.floor((diff % 60000) / 1000);

        if (d > 0) {
          clock.textContent = d + (d === 1 ? ' dag ' : ' dage ') +
            h + ' t ' + m + ' min';
        } else {
          clock.textContent = h + ' t ' + m + ' min ' + sec + ' sek';
        }
      };
      tick();
      var timer = setInterval(tick, 1000);
    }
  }
})();

/* ==========================================================================
   SOULLIX PRODUCT — blokke i koebspanelet.
   Egen IIFE, saa den koerer uafhaengigt af galleriet og kan koeres igen
   naar theme-editoren genindlaeser en sektion.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return String(n).padStart(2, '0'); }

  /* ------------------------------------------------- TRUSTPILOT-SLIDER --- */
  function initTrustSliders(scope) {
    scope.querySelectorAll('[data-sx-tp]:not([data-sx-tp-ready])').forEach(function (box) {
      box.setAttribute('data-sx-tp-ready', '1');

      var slides = box.querySelectorAll('[data-sx-tp-slide]');
      var dots = box.querySelectorAll('[data-sx-tp-dot]');
      if (slides.length < 2) return;

      var speed = parseInt(box.dataset.sxTpSpeed, 10) || 5000;
      var i = 0;
      var timer = null;

      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
        dots.forEach(function (el, k) {
          el.classList.toggle('is-active', k === i);
          el.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
      }

      function start() {
        if (reduce) return;
        stop();
        timer = setInterval(function () { show(i + 1); }, speed);
      }

      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (dot, k) {
        dot.addEventListener('click', function () { show(k); start(); });
      });

      // Staar musen eller en finger paa kortet, skal teksten ikke skifte vaek
      box.addEventListener('mouseenter', stop);
      box.addEventListener('mouseleave', start);
      box.addEventListener('focusin', stop);
      box.addEventListener('focusout', start);

      show(0);
      start();
    });
  }

  /* -------------------------------------------------------- NEDTAELLING --- */
  function initCountdowns(scope) {
    scope.querySelectorAll('[data-sx-cd]:not([data-sx-cd-ready])').forEach(function (box) {
      box.setAttribute('data-sx-cd-ready', '1');

      var until = Date.parse(box.dataset.sxCdUntil);
      var d = box.querySelector('[data-sx-cd-d]');
      var h = box.querySelector('[data-sx-cd-h]');
      var m = box.querySelector('[data-sx-cd-m]');
      var s = box.querySelector('[data-sx-cd-s]');
      var title = box.querySelector('.sx__cd-title');

      if (isNaN(until) || !d || !h || !m || !s) { box.style.display = 'none'; return; }

      var timer = setInterval(tick, 1000);
      tick();

      function tick() {
        var left = until - Date.now();
        if (left <= 0) {
          clearInterval(timer);
          box.classList.add('is-over');
          if (title) title.textContent = box.dataset.sxCdOver || '';
          if (!box.dataset.sxCdOver) box.style.display = 'none';
          return;
        }
        d.textContent = pad(Math.floor(left / 86400000));
        h.textContent = pad(Math.floor((left % 86400000) / 3600000));
        m.textContent = pad(Math.floor((left % 3600000) / 60000));
        s.textContent = pad(Math.floor((left % 60000) / 1000));
      }
    });
  }

  /* ---------------------------------------------------------------------
     BESTIL INDEN-FRISTEN
     Der er altid en levende nedtaelling. Er vi inden for dagens frist paa
     en afsendelsesdag, taeller den ned til i dag. Ellers ruller den frem
     til naeste afsendelsesdag og skriver ugedagen i teksten.
     --------------------------------------------------------------------- */
  var DK_DAYS_TXT = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];

  function initCutoffs(scope) {
    scope.querySelectorAll('[data-sx-cut]:not([data-sx-cut-ready])').forEach(function (box) {
      box.setAttribute('data-sx-cut-ready', '1');

      var out = box.querySelector('[data-sx-cut-text]');
      if (!out) return;

      var parts = (box.dataset.sxCutTime || '15:30').split(':');
      var cutH = parseInt(parts[0], 10);
      var cutM = parseInt(parts[1], 10) || 0;
      if (isNaN(cutH)) { cutH = 15; cutM = 30; }

      // 1 = mandag … 7 = soendag, samme som ISO
      var days = (box.dataset.sxCutDays || '1,2,3,4,5')
        .split(',')
        .map(function (n) { return parseInt(n.trim(), 10); })
        .filter(function (n) { return n >= 1 && n <= 7; });

      if (!days.length) days = [1, 2, 3, 4, 5];

      var before = box.dataset.sxCutBefore || 'Bestil inden';
      var todayTxt = box.dataset.sxCutToday || 'saa sender vi i dag';
      var nextTxt = box.dataset.sxCutNext || 'saa sender vi {dag}';

      function isoDay(d) { return d.getDay() === 0 ? 7 : d.getDay(); }

      // Naeste tidspunkt hvor pakken kan naa afsted
      function nextDeadline(now) {
        for (var add = 0; add < 14; add++) {
          var d = new Date(now);
          d.setDate(d.getDate() + add);
          d.setHours(cutH, cutM, 0, 0);
          if (days.indexOf(isoDay(d)) !== -1 && d > now) {
            return { at: d, offset: add };
          }
        }
        return null;
      }

      function clockText(ms) {
        var d = Math.floor(ms / 86400000);
        var h = Math.floor((ms % 86400000) / 3600000);
        var m = Math.floor((ms % 3600000) / 60000);
        var sec = Math.floor((ms % 60000) / 1000);

        // Vi starter ved den stoerste enhed der ikke er nul og tager de to
        // naeste med. Et nul midt i tallet skal blive staaende, ellers
        // laeses "1 dag 0 timer 44 min" som "1 dag 44 min".
        if (d > 0) {
          return d + (d === 1 ? ' dag ' : ' dage ') +
                 h + (h === 1 ? ' time ' : ' timer ') + m + ' min';
        }
        if (h > 0) {
          return h + (h === 1 ? ' time ' : ' timer ') + pad(m) + ' min ' + pad(sec) + ' sek';
        }
        return m + ' min ' + pad(sec) + ' sek';
      }

      var timer = setInterval(tick, 1000);
      tick();

      function tick() {
        var now = new Date();
        var next = nextDeadline(now);

        if (!next) { box.style.display = 'none'; clearInterval(timer); return; }

        var sameDay = next.offset === 0;
        box.classList.toggle('is-next', !sameDay);

        var tail;
        if (sameDay) {
          tail = todayTxt;
        } else {
          var word = next.offset === 1 ? 'i morgen' : DK_DAYS_TXT[next.at.getDay()];
          tail = nextTxt.replace('{dag}', word);
        }

        out.innerHTML = '';
        out.appendChild(document.createTextNode(before + ' '));
        var b = document.createElement('b');
        b.textContent = clockText(next.at - now);
        out.appendChild(b);
        out.appendChild(document.createTextNode(' ' + tail));
      }
    });
  }

  /* ------------------------------------------------ DAGENS DATO I GAVE --- */
  function initToday(scope) {
    scope.querySelectorAll('[data-sx-today]').forEach(function (el) {
      // Liquid har allerede skrevet datoen. Vi skriver den igen paa klienten,
      // saa en cachet side ikke kan komme til at vise gaars dato.
      try {
        el.textContent = new Date().toLocaleDateString('da-DK', {
          day: 'numeric',
          month: 'long'
        });
      } catch (e) { /* browseren kan ikke da-DK, saa beholder vi Liquid-datoen */ }
    });
  }

  function initAll(scope) {
    var root = scope || document;
    initTrustSliders(root);
    initCountdowns(root);
    initCutoffs(root);
    initToday(root);
  }

  initAll(document);

  // Theme-editoren skifter sektioner ud uden reload
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();


/* ------------------------------------------------------------------ UGC-ringe
   Klippene henter foerst data naar de er i syne, og saettes paa pause igen
   naar de ruller ud. Klik aabner klippet stort i en overlay.               */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var modal = null;
  var modalVideo = null;

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'sx__ugc-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="sx__ugc-modal-bg" data-sx-ugc-close></div>' +
      '<div class="sx__ugc-modal-box" role="dialog" aria-modal="true">' +
      '<button class="sx__ugc-close" type="button" aria-label="Luk" data-sx-ugc-close>&times;</button>' +
      '<video playsinline loop controls></video></div>';
    document.body.appendChild(modal);
    modalVideo = modal.querySelector('video');
    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-sx-ugc-close')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.hidden && e.key === 'Escape') closeModal();
    });
    return modal;
  }

  function openModal(src) {
    buildModal();
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    modalVideo.src = src;
    modalVideo.muted = false;
    var p = modalVideo.play();
    if (p && p.catch) p.catch(function () { modalVideo.muted = true; modalVideo.play(); });
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();
  }

  function initUgc(scope) {
    var roots = (scope || document).querySelectorAll('[data-sx-ugc]:not([data-sx-ugc-ready])');
    if (!roots.length) return;

    roots.forEach(function (root) {
      root.setAttribute('data-sx-ugc-ready', '1');

      root.querySelectorAll('[data-sx-ugc-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          openModal(btn.getAttribute('data-sx-ugc-open'));
        });
      });

      var vids = root.querySelectorAll('.sx__ugc-card video');
      if (reduce || !('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            v.muted = true;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.3 });

      vids.forEach(function (v) { v.muted = true; io.observe(v); });
    });
  }

  initUgc(document);
  document.addEventListener('shopify:section:load', function (e) { initUgc(e.target); });
})();

/* ----------------------------------------------------------------------
   ANBEFALINGS-BADGE
   Info-ikonet i den moerke pille folder forklaringen ud. Den lukker igen
   ved klik udenfor eller Escape, saa den aldrig staar og daekker for
   koebsknappen.
---------------------------------------------------------------------- */
(function () {
  function closeBox(box) {
    box.classList.remove('is-open');
    var pop = box.querySelector('[data-sx-rec-pop]');
    var btn = box.querySelector('[data-sx-rec-toggle]');
    if (pop) pop.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function initRec(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-sx-rec]').forEach(function (box) {
      var btn = box.querySelector('[data-sx-rec-toggle]');
      var pop = box.querySelector('[data-sx-rec-pop]');
      if (!btn || !pop || btn.dataset.sxRecBound) return;
      btn.dataset.sxRecBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        document.querySelectorAll('.sx__rec.is-open').forEach(function (other) {
          if (other !== box) closeBox(other);
        });
        var open = !box.classList.contains('is-open');
        box.classList.toggle('is-open', open);
        pop.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('.sx__rec.is-open').forEach(function (box) {
      if (!box.contains(e.target)) closeBox(box);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    document.querySelectorAll('.sx__rec.is-open').forEach(function (box) {
      closeBox(box);
    });
  });

  initRec(document);
  document.addEventListener('shopify:section:load', function (e) { initRec(e.target); });
})();
